/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../../_chunks/dep-fa22eda7.mjs';
import { toRefs, computed } from 'vue';
import useClassName from './useClassName.mjs';
import useCommonClassName from '../../hooks/useCommonClassName.mjs';
import '../../_chunks/dep-8a0ff305.mjs';
import '../../hooks/useConfig.mjs';
import '../../config-provider/useConfig.mjs';
import '../../_chunks/dep-1f286011.mjs';
import '../../_chunks/dep-34428f12.mjs';
import '../../_chunks/dep-1c40d002.mjs';
import '../../_chunks/dep-3ced59c9.mjs';
import '../../_chunks/dep-4371fb57.mjs';
import '../../_chunks/dep-31d34e52.mjs';
import '../../_chunks/dep-67e8723b.mjs';
import '../../_chunks/dep-0bf03d55.mjs';
import '../../_chunks/dep-5b5daf08.mjs';
import '../../_chunks/dep-95049222.mjs';
import '../../_chunks/dep-ac19a2b6.mjs';
import '../../_chunks/dep-90d97bcb.mjs';
import '../../_chunks/dep-c8679a16.mjs';
import '../../_chunks/dep-939a74d6.mjs';
import '../../_chunks/dep-61150968.mjs';
import '../../_chunks/dep-e9ff4ce8.mjs';
import '../../_chunks/dep-c54c9f32.mjs';
import '../../_chunks/dep-e4f65bc4.mjs';
import '../../_chunks/dep-45572c49.mjs';
import '../../_chunks/dep-1aa18f5f.mjs';
import '../../_chunks/dep-e09a06d8.mjs';
import '../../_chunks/dep-07f3660d.mjs';
import '../../_chunks/dep-0d3220b0.mjs';
import '../../_chunks/dep-895678a0.mjs';
import '../../_chunks/dep-b2bdc7b9.mjs';
import '../../_chunks/dep-0f45a6e0.mjs';
import '../../_chunks/dep-b390ff23.mjs';
import '../../_chunks/dep-35a4fd8d.mjs';
import '../../_chunks/dep-54378e60.mjs';
import '../../_chunks/dep-25b8bf4b.mjs';
import '../../_chunks/dep-c40264c0.mjs';
import '../../_chunks/dep-9d499243.mjs';
import '../../_common/js/global-config/default-config.mjs';
import '../../_common/js/global-config/locale/zh_CN.mjs';
import '../../_chunks/dep-0927ceb7.mjs';
import '../../_chunks/dep-f0bd05df.mjs';
import '../../config-provider/type.mjs';

function formatCSSUnit(unit) {
  if (!unit) return unit;
  return isNaN(Number(unit)) ? unit : "".concat(unit, "px");
}
function useStyle(props) {
  var _toRefs = toRefs(props),
    size = _toRefs.size,
    bordered = _toRefs.bordered,
    stripe = _toRefs.stripe,
    hover = _toRefs.hover,
    verticalAlign = _toRefs.verticalAlign,
    height = _toRefs.height,
    maxHeight = _toRefs.maxHeight,
    tableContentWidth = _toRefs.tableContentWidth;
  var _useClassName = useClassName(),
    tableBaseClass = _useClassName.tableBaseClass,
    tableAlignClasses = _useClassName.tableAlignClasses;
  var _useCommonClassName = useCommonClassName(),
    sizeClassNames = _useCommonClassName.sizeClassNames;
  var tableClasses = computed(function () {
    var _ref;
    return [tableBaseClass.table, (_ref = {}, _defineProperty(_ref, sizeClassNames[size.value], size.value !== "medium"), _defineProperty(_ref, tableBaseClass.bordered, bordered.value), _defineProperty(_ref, tableBaseClass.striped, stripe.value), _defineProperty(_ref, tableBaseClass.hover, hover.value), _defineProperty(_ref, tableBaseClass.loading, props.loading), _defineProperty(_ref, tableBaseClass.affixedHeader, props.headerAffixedTop), _defineProperty(_ref, tableBaseClass.rowspanAndColspan, props.rowspanAndColspan), _defineProperty(_ref, tableAlignClasses[verticalAlign.value], verticalAlign.value !== "middle"), _ref)];
  });
  var tableContentStyles = computed(function () {
    return {
      height: formatCSSUnit(height.value),
      maxHeight: formatCSSUnit(maxHeight.value)
    };
  });
  var tableElementStyles = computed(function () {
    return {
      width: formatCSSUnit(tableContentWidth.value)
    };
  });
  return {
    tableClasses: tableClasses,
    sizeClassNames: sizeClassNames,
    tableElementStyles: tableElementStyles,
    tableContentStyles: tableContentStyles
  };
}

export { useStyle as default, formatCSSUnit };
//# sourceMappingURL=useStyle.mjs.map
